<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Atributos</p>
        </template>
        <b-row>                            
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button variant="info" class="text-white" :to="{name: 'registerAttributeEmpresa'}">Registrar Nuevo</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover  
                :items="attributes">
                <template v-slot:cell(codigo)="data">
                    {{ data.item.codigo }}
                </template>
                <template v-slot:cell(nombre)="data">
                    {{ data.item.nombre }}
                </template>
                <template v-slot:cell(tipo)="data">
                    {{ data.item.tipo }}
                </template>
                <template v-slot:cell(status)="{ item }">
                    <b-form-checkbox v-model="item.status" name="check-button" switch  @change="$emit('update-status-attribute', item)"  />
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" v-b-tooltip.hover.right title="Editar" class="text-white" 
                    :to="{name: 'editAttributeEmpresa', params:{ id: item.id}}">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="attributes.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "AttributesTable",
    props: {
        attributes: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'codigo', label: 'Código', sortable: true},
                { key: 'nombre', label: 'Atributo', sortable: true},
                { key: 'tipo', label: 'Tipo', sortable: true},
                { key: 'status', label: 'Estado', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-attributes-list-empresa');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);            
        }
    }
};

</script>
<style scoped>

</style>